import { useTranslation } from 'react-i18next';
import {
  applyConsent,
  getStoredConsent,
  type ConsentStatus,
} from '../lib/analytics';
import { useState } from 'react';

export function CookieConsent() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(() => getStoredConsent() === null);

  function handleChoice(status: ConsentStatus) {
    applyConsent(status);
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className='fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-bg p-4 shadow-elevated sm:p-6'>
      <div className='mx-auto flex max-w-5xl flex-col gap-4 sm:flex-row sm:items-center sm:justify-between'>
        <p className='text-sm text-fg-muted'>{t('consent.message')}</p>
        <div className='flex shrink-0 gap-3'>
          <button
            onClick={() => handleChoice('declined')}
            className='rounded-md border border-border px-4 py-2 text-sm font-medium text-fg-muted transition-colors hover:bg-surface hover:text-fg'
          >
            {t('consent.decline')}
          </button>
          <button
            onClick={() => handleChoice('accepted')}
            className='rounded-md bg-accent px-4 py-2 text-sm font-medium text-bg transition-colors hover:opacity-90'
          >
            {t('consent.accept')}
          </button>
        </div>
      </div>
    </div>
  );
}
